import { InjectionToken } from '@angular/core';
import type { SeoConfig } from './seo.interface';

export const SEO_CONFIG = new InjectionToken<SeoConfig>('SeoConfig');
